// alterado - revisado

import React from 'react'

import { FieldArray } from 'formik'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem5,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TextValidatorText,
} from '../../../business-components/TextValidator/TextValidator'

import { 
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import tipoEsporteHobbyRiscoList from '../../../business-rules/List/tipoEsporteHobbyRiscoList'

import {
    IconButtonClearEntradaDados
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    processaRegistrosDefaultIniciaisEsporteHobbyRisco,
    processaAlteracaoEsporteHobbyRiscoTipoEsporteHobbyRisco,
} from './RiscosServiceEsporteHobbyRisco'

const RiscosFormEsporteHobbyRisco = ({ familiar, values, handleChange }) => {

    processaRegistrosDefaultIniciaisEsporteHobbyRisco(values, familiar)

    return (
        <FieldArray name="esportesHobbiesRisco">
            {(arrayHelpers) => (
                <DivForm>
                    <DivForm
                        style={{
                            display: values.esportesHobbiesRisco && values.esportesHobbiesRisco.filter(esporteHobbyRisco => esporteHobbyRisco.familiar === familiar).length > 0 ? "block" : "none"
                        }}
                    >
                        {values.esportesHobbiesRisco?.map((item, ind) => {
                            return item.familiar === familiar ? (
                                <GridContainer
                                    key={ind}
                                >
                                    <GridItem12>
                                        <GridContainer>
                                            <GridItem1 />

                                            <GridItem5>
                                                <TextFieldTextSelect
                                                    name={`esportesHobbiesRisco[${ind}].tipoEsporteHobbyRisco`}
                                                    label={LABEL.tipoEsporteHobbyRisco}
                                                    value={item.tipoEsporteHobbyRisco || ''}
                                                    onChange={handleChange}
                                                    list={tipoEsporteHobbyRiscoList}
                                                    onBlur={processaAlteracaoEsporteHobbyRiscoTipoEsporteHobbyRisco(item)}
                                                />
                                            </GridItem5>
                                            <GridItem5
                                                style={{
                                                    display:
                                                        item.tipoEsporteHobbyRisco !== HARDCODE.idTipoEsporteHobbyRiscoOutros 
                                                            ? "block"
                                                            : "none"
                                                }}
                                            />
                                            <GridItem5
                                                style={{
                                                    display:
                                                        item.tipoEsporteHobbyRisco === HARDCODE.idTipoEsporteHobbyRiscoOutros 
                                                            ? "block"
                                                            : "none"
                                                }}
                                            >
                                                <TextValidatorText
                                                    name={`esportesHobbiesRisco[${ind}].tipoEsporteHobbyRiscoOutros`}
                                                    label={LABEL.tipoEsporteHobbyRiscoOutros}
                                                    value={item.tipoEsporteHobbyRiscoOutros || ''}
                                                    onChange={handleChange}
                                                    tamMax={TAMMAX.tipoEsporteHobbyRiscoOutros}
                                                />
                                            </GridItem5>
                                            <GridItem1>
                                                <IconButtonClearEntradaDados
                                                    onClick={() =>
                                                        arrayHelpers.remove(ind)
                                                    }
                                                />
                                            </GridItem1>
                                        </GridContainer>
                                    </GridItem12>
                                </GridContainer>
                            )
                            : 
                            (
                                <DivForm
                                    key={ind}
                                />
                            )
                        })}
                    </DivForm>

                    <GridContainer>
                        <GridItem1 />

                        <ButtonIncluirLinha
                            label={LABEL.buttonIncluirEsporteHobbyRisco} 
                            onClick={() => 
                                arrayHelpers.push({
                                    familiar: familiar
                                })
                            }
                        />
                    </GridContainer>
                </DivForm>
            )}
        </FieldArray>
    )
}

export default RiscosFormEsporteHobbyRisco